import React from 'react';

const playerContext = React.createContext();

export default playerContext;
